import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';

export const PartialRefundDialog = ({
  open, onOpenChange, selectedBooking,
  prConfirmedQty, setPrConfirmedQty,
  prAmazonAccount, setPrAmazonAccount,
  prReason, setPrReason,
  submitting, handlePartialRefund,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="max-w-[95vw] sm:max-w-md max-h-[90vh] overflow-y-auto">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-orange-700">Partial Refund</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-3 mt-2">
            {selectedBooking && (
              <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1">
                <p><b>TXN:</b> <span className="font-mono">{selectedBooking.transaction_id}</span></p>
                <p><b>Agency:</b> {selectedBooking.agency_name}</p>
                <p><b>Booked Qty:</b> {selectedBooking.quantity} cylinders</p>
                <p><b>Rate:</b> ₹{selectedBooking.rate} + ₹{selectedBooking.fee_per_cylinder}/cyl fee</p>
                <p><b>Source:</b> <span className={`px-1.5 py-0.5 rounded text-xs font-bold ${selectedBooking.source?.toLowerCase() === 'tataneu' ? 'bg-blue-100 text-blue-700' : selectedBooking.source?.toLowerCase() === 'amazon' ? 'bg-orange-100 text-orange-700' : 'bg-gray-100 text-gray-700'}`}>{selectedBooking.source?.toUpperCase() || 'CASH'}</span></p>
                <p><b>Date:</b> {selectedBooking.booking_date}</p>
                <p className="text-xs text-emerald-700 bg-emerald-50 px-2 py-1 rounded mt-1">Refund → Distributor wallet + Staff wallet mein credit hoga (same TXN)</p>
              </div>
            )}

            {selectedBooking?.partial_refund && (
              <div className="p-3 bg-red-50 border-2 border-red-400 rounded-lg">
                <p className="font-bold text-red-700 text-sm">ALREADY ADJUSTED — DUPLICATE NAHI HOGA</p>
                <div className="mt-1 text-xs text-red-600 space-y-0.5">
                  <p>TXN: <b className="font-mono">{selectedBooking.partial_refund.transaction_id}</b></p>
                  <p>Refund: <b>{selectedBooking.partial_refund.refund_qty} cylinders</b> (Confirmed {selectedBooking.partial_refund.confirmed_qty}/{selectedBooking.partial_refund.original_qty})</p>
                  <p>Amount: <b>₹{selectedBooking.partial_refund.refund_amount?.toLocaleString('en-IN')}</b></p>
                  <p>Done by: <b>{selectedBooking.partial_refund.done_by_name}</b> at {selectedBooking.partial_refund.done_at?.slice(0, 16)}</p>
                  {selectedBooking.partial_refund.amazon_account && <p>Accounts: {selectedBooking.partial_refund.amazon_account}</p>}
                </div>
              </div>
            )}

            {!selectedBooking?.partial_refund && (
              <div>
                <Label className="text-sm font-bold">Agency ne kitna confirm kiya? <span className="text-red-500">*</span></Label>
                <Input type="number" min="0" max={selectedBooking?.quantity} value={prConfirmedQty} onChange={e => {
                  const val = parseInt(e.target.value);
                  if (!isNaN(val) && val > (selectedBooking?.quantity || 0)) {
                    setPrConfirmedQty(String(selectedBooking?.quantity || 0));
                  } else {
                    setPrConfirmedQty(e.target.value);
                  }
                }} placeholder={`0 se ${selectedBooking?.quantity || 0} tak`} data-testid="pr-confirmed-qty" />
                <p className="text-[10px] text-gray-400 mt-1">Maximum refund: {selectedBooking?.quantity} cylinders. Confirmed qty 0 se {selectedBooking?.quantity} ke beech hona chahiye.</p>

                {prConfirmedQty !== '' && selectedBooking && (() => {
                  const confirmed = parseInt(prConfirmedQty);
                  const booked = selectedBooking.quantity;
                  if (isNaN(confirmed) || confirmed < 0) return <p className="text-xs text-red-600 mt-1">Valid number enter karein</p>;
                  if (confirmed > booked) return <p className="text-xs text-red-600 mt-1">Confirmed qty ({confirmed}) booked qty ({booked}) se zyada nahi ho sakta!</p>;
                  if (confirmed === booked) return <p className="text-xs text-gray-500 mt-1">Koi refund nahi — sab confirm hua</p>;
                  const refundQty = booked - confirmed;
                  const refundAmt = refundQty * (selectedBooking.rate + (selectedBooking.fee_per_cylinder || 0));
                  return (
                    <div className="mt-2 p-2 bg-orange-50 border border-orange-200 rounded text-xs">
                      <p className="font-bold text-orange-800">Refund: {refundQty} cylinders (out of {booked})</p>
                      <p className="text-orange-700">Amount: ₹{refundAmt.toLocaleString('en-IN')} → Distributor + Staff</p>
                    </div>
                  );
                })()}
              </div>
            )}
            <div>
              <Label className="text-sm">{selectedBooking?.source?.toLowerCase() === 'tataneu' ? 'TataNeu' : selectedBooking?.source?.toLowerCase() === 'amazon' ? 'Amazon' : 'Platform'} Accounts (paste multiple — ek line mein ek)</Label>
              <Textarea value={prAmazonAccount} onChange={e => setPrAmazonAccount(e.target.value)} placeholder={`account1@example.com\naccount2@example.com`} rows={3} className="font-mono text-xs" data-testid="pr-amazon-account" />
              {prAmazonAccount && prAmazonAccount.trim().length > 0 && (() => {
                const accounts = prAmazonAccount.split(/[\n,;]+/).map(s => s.trim()).filter(s => s.length > 0);
                if (accounts.length === 0) return null;
                return (
                  <div className="mt-2 space-y-1">
                    <p className="text-[10px] text-gray-500 font-bold">{accounts.length} account(s) detected:</p>
                    {accounts.map((acc, i) => (
                      <div key={`acc-${acc}-${i}`} className="flex items-center gap-2 bg-gray-50 rounded px-2 py-1 group">
                        <span className="text-xs font-mono flex-1 select-all">{acc}</span>
                        <button type="button" onClick={(e) => { e.preventDefault(); navigator.clipboard.writeText(acc); toast.success(`Copied: ${acc}`); }} className="opacity-0 group-hover:opacity-100 text-blue-600 hover:text-blue-800 transition-opacity" data-testid={`copy-acc-${i}`}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                        </button>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
            <div>
              <Label className="text-sm">Reason</Label>
              <Input value={prReason} onChange={e => setPrReason(e.target.value)} placeholder="Agency confirmed less..." data-testid="pr-reason" />
            </div>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        {!selectedBooking?.partial_refund && (
          <AlertDialogAction onClick={handlePartialRefund} className="bg-orange-600 hover:bg-orange-700" disabled={submitting || !prConfirmedQty || parseInt(prConfirmedQty) >= (selectedBooking?.quantity || 0)} data-testid="pr-confirm-btn">
            {submitting ? 'Processing...' : 'Process Partial Refund'}
          </AlertDialogAction>
        )}
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
